// src/utils/tokenProvider.js
let tokenGetter = async () => null;

export function registerTokenProvider(fn) {
  tokenGetter = fn;
}

export async function getToken() {
  try {
    return await tokenGetter();
  } catch {
    return null;
  }
}
